<template>
    <div>
        <h1 v-if="!this.minimal"><small>Van:</small> {{ username(teacher) }}</h1>
        <div class="feedback-compliments" v-if="compliments.length">
            <component :is="heading">Dit heb je goed gedaan</component>
            <ul>
                <li v-for="compliment in compliments">{{ compliment.content }}</li>
            </ul>
        </div>

        <div class="feedback-remarks" v-if="remarks.length">
            <component :is="heading">Besteed hier nog wat aandacht aan</component>
            <ul>
                <li v-for="remark in remarks">{{ remark.content }}</li>
            </ul>
        </div>

        <div class="feedback-comments" v-if="feedback.content">
            <component :is="heading">Opmerkingen</component>
            <p class="preformatted">{{ feedback.content }}</p>
        </div>

    </div>
</template>


<script>

import { username } from 'js/helpers/transformers'

export default {
    name: 'TeacherFeedbackPresenter',

    props: {
        feedback: {},
        minimal: {
            type: Boolean,
            default: false,
        }
    },

    components: {},

    computed: {
        remarks: function() {
            return this.feedback.remarks == null ? null : this.feedback.remarks.map( t => this.$store.state.feedback.remarks[t] )
        },
        compliments: function() {
            return this.feedback.compliments == null ? null : this.feedback.compliments.map( t => this.$store.state.feedback.compliments[t] )
        },
        teacher: function() {
            return this.feedback.teacher.map( t => this.$store.state.users.storage[t] )[0]
        },

        heading: function() {
            return this.minimal ? 'h3' : 'h2'
        }
    },

    methods: {
        username,
    }
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// TeacherFeedback.vue?ba33122a